module.exports = __webpack_public_path__ + "static/atc-e9bc6efceef8bdebbc6e2a121c6fe978.png";